import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { secciones } from "../../../../datos";
import { Accordion } from "../../../Accordion/Accordion";
import { Vacantes as VacantesApi } from "../../../../api";

const vacantesApi = new VacantesApi();

export function GestionHumanaPages() {
  const [vacantes, setVacantes] = useState([]);

  useEffect(() => {
    vacantesApi.getAll(true).then((data) => {
      if (data?.length) setVacantes(data);
    }).catch(() => {});
  }, []);

  return (
    <>
      {secciones?.map((datos, index) => (
        <div key={index} className="py-12 md:py-20 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            {/* Header */}
            <div className="text-center mb-10 md:mb-16">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#151C84]/10 text-[#151C84] text-sm font-bold rounded-full mb-6 border border-[#151C84]/15">
                <span className="w-2 h-2 rounded-full bg-[#C81416]" />
                Únete a Nosotros
              </span>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-4 text-[#151C84]">
                Nuestros Valores Corporativos
              </h2>
              <div className="flex items-center justify-center gap-2 mt-4">
                <div className="h-0.5 w-12 bg-[#C81416] rounded-full" />
                <div className="h-1.5 w-1.5 rounded-full bg-[#C81416]" />
                <div className="h-0.5 w-12 bg-[#C81416] rounded-full" />
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-7xl mx-auto">
              {/* Vision & Mission */}
              <div className="space-y-8">
                {datos?.recurso_humano[0]?.contenido[0].quebuscamos.map(
                  (dato, idx) => (
                    <div
                      key={idx}
                      className="bg-white p-8 rounded-2xl shadow-soft-sm hover:shadow-soft-md transition-all duration-300"
                    >
                      <div className="flex items-start gap-4">
                        <div className={`w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 ${
                          idx === 0 ? "bg-[#151C84]" : "bg-[#C81416]"
                        }`}>
                          <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {idx === 0 ? (
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            ) : (
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                            )}
                          </svg>
                        </div>
                        <div>
                          <h3 className="text-2xl font-bold text-[#151C84] mb-3">
                            {dato.title}
                          </h3>
                          <p className="text-gray-600 leading-relaxed">
                            {dato.descripcion}
                          </p>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>

              {/* Values */}
              <div className="bg-white p-8 rounded-2xl shadow-soft-sm">
                <h3 className="text-2xl font-bold text-[#151C84] mb-6 flex items-center gap-3">
                  <div className="w-10 h-10 bg-[#151C84] rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                    </svg>
                  </div>
                  Nuestros Valores
                </h3>
                <div className="space-y-3">
                  {datos?.recurso_humano[0]?.contenido[0].valores.map((dato, idx) => {
                    const { title } = dato;
                    return (
                      <Accordion
                        key={idx}
                        title={title}
                        textSize="text-[1rem]"
                        bgContentColor="bg-gray-50"
                        drawDown={true}
                      />
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Video Section */}
            <div className="mt-20 max-w-5xl mx-auto">
              <div className="p-5 sm:p-8 md:p-12 rounded-3xl shadow-soft-lg" style={{background:"linear-gradient(135deg,#151C84 0%,#0d125c 100%)"}}>
                <div className="text-center mb-8">
                  <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
                    Conoce Nuestra Familia
                  </h3>
                  <p className="text-white/80 max-w-2xl mx-auto">
                    Descubre por qué somos el equipo ideal para ti. Mira nuestro video corporativo.
                  </p>
                </div>
                <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                  <video
                    src={datos.image[0].video_rrhh}
                    controls
                    preload="auto"
                    className="w-full"
                  />
                </div>
              </div>
            </div>

            {/* Vacantes Section */}
            {vacantes.length > 0 && (
              <div id="vacantes" className="mt-20">
                <div className="text-center mb-12">
                  <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#151C84]/10 text-[#151C84] text-sm font-bold rounded-full mb-6 border border-[#151C84]/15">
                    <span className="w-2 h-2 rounded-full bg-[#C81416]" />
                    Oportunidades
                  </span>
                  <h2 className="text-4xl font-extrabold text-[#151C84] mb-4">Vacantes Disponibles</h2>
                  <div className="flex items-center justify-center gap-2 mt-4">
                    <div className="h-0.5 w-12 bg-[#C81416] rounded-full" />
                    <div className="h-1.5 w-1.5 rounded-full bg-[#C81416]" />
                    <div className="h-0.5 w-12 bg-[#C81416] rounded-full" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-5xl mx-auto">
                  {vacantes.map((v) => (
                    <div key={v.id} className="bg-white rounded-2xl border border-gray-100 shadow-[0_2px_16px_rgba(21,28,132,0.06)] hover:shadow-[0_8px_32px_rgba(21,28,132,0.12)] p-6 transition-all duration-300 hover:-translate-y-1 group">
                      <div className="flex items-start gap-4">
                        <div className="w-12 h-12 bg-[#151C84]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                          <svg className="w-6 h-6 text-[#151C84]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                          </svg>
                        </div>
                        <div className="flex-1 min-w-0">
                          <h3 className="font-bold text-[#151C84] text-lg leading-tight mb-2">{v.titulo}</h3>
                          <div className="flex flex-wrap gap-2 mb-3">
                            {v.departamento && (
                              <span className="text-[11px] bg-[#151C84]/10 text-[#151C84] border border-[#151C84]/15 px-2 py-0.5 rounded-full font-semibold">{v.departamento}</span>
                            )}
                            {v.modalidad && (
                              <span className="text-[11px] bg-indigo-50 text-indigo-700 border border-indigo-200 px-2 py-0.5 rounded-full font-semibold">{v.modalidad}</span>
                            )}
                          </div>
                          {v.descripcion && <p className="text-gray-500 text-sm leading-relaxed line-clamp-2 mb-3">{v.descripcion}</p>}
                          <div className="flex items-center gap-4 text-xs text-gray-400">
                            {v.ubicacion && (
                              <span className="flex items-center gap-1">
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                {v.ubicacion}
                              </span>
                            )}
                            {v.salario && <span>{v.salario}</span>}
                          </div>
                        </div>
                      </div>
                      <div className="mt-4 pt-4 border-t border-gray-50">
                        <Link to="/recursohumano/formulario"
                          className="inline-flex items-center gap-2 text-sm font-bold text-[#151C84] hover:text-[#C81416] transition-colors group-hover:gap-3">
                          Aplicar a esta vacante
                          <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* CTA Section */}
            <div className="mt-16 text-center">
              <div className="bg-white p-5 sm:p-8 md:p-12 rounded-3xl shadow-soft-md max-w-4xl mx-auto">
                <h3 className="text-2xl sm:text-3xl font-bold text-[#151C84] mb-4">
                  ¿Te identificas con nuestros valores?
                </h3>
                <p className="text-gray-600 mb-8 text-lg">
                  Si buscas un lugar donde crecer profesionalmente y formar parte de un equipo comprometido, ¡este es tu lugar!
                </p>
                <Link
                  to="/recursohumano/formulario"
                  className="px-10 py-4 text-lg inline-flex items-center gap-3 bg-[#151C84] hover:bg-[#0d125c] text-white font-bold rounded-xl transition-all shadow-[0_4px_14px_rgba(21,28,132,0.3)]"
                >
                  Postularme Ahora
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
